import script from "./notificationsDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./notificationsDropdown.vue?vue&type=script&setup=true&lang=js"

import "./notificationsDropdown.vue?vue&type=style&index=0&id=2ca89002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca89002"]])

export default __exports__